<template>
   <div class="">
       <FormMeta :submit-function="updateMeta" />
   </div>
</template>

<script>
import FormMeta from './FormMeta'

export default {
  name: "tableItems",
  components:{FormMeta},
  data() {
    return {
      

    };
  },
  methods:{
    updateMeta(form){
      form.id = this.$route.params.meta;
      this.$store.dispatch('Meta/updateMeta',form)
    }
  },

};
</script>